import "../../styles/shared/fonts.css";
import "../../styles/shared/icomoon_font.css";
import "../../styles/shared/icomoon_icons.css";

import '../../styles/desktop/_bottom.css'
import Currency from '../shared/currency';
import './../shared/sideMenu';
import './../shared/latest_news';
import './../shared/main_news';

import 'jquery.marquee/jquery.marquee.js';


((($) => {

    new Currency('.currency');

    $('.js-weather').change(function () {
        let _val = $(this).val();
        let _parent = $(this).closest('.html__items');
        if ($(this).data('loaded') === false) {
            _parent.find(`#${_val}`).data('loaded', true);
        }
        _parent.find('.html__item--group').addClass('hide');
        _parent.find(`#${_val}`).removeClass('hide');
    });

    $('.latest__marquee').marquee();

})(jQuery));
